import { BookService } from "./../../shared/book.service";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Book } from "../../shared/book.model";

declare let alertify: any;
declare let localforage: any;
declare let window: any;

@Component({
	selector: "app-biletcategory",
	templateUrl: "./biletcategory.component.html",
	styleUrls: ["./biletcategory.component.css"],
})
export class BiletcategoryComponent implements OnInit {
	listBook!: any[];
	bookCode!: Book;
	listCategory: any[] = [];
	paramsObject: any = "";
	code: string = "";
	constructor(private service: BookService, private activatedRoute: ActivatedRoute, private router: Router) { }

	ngOnInit() {
		document.body.className = 'bl-page-category';
		if(document.body.offsetWidth < 760) document.body.className = 'bl-view-mobile bl-page-category';
		
		this.handleParams();
		var url = this.router.url.split("/")[1];
		var booksOnline = this.service.getBooks();
		var products: any = (booksOnline as any).default;
		var listItem = [];
		for (const property in products) {
			listItem.push(products[property]);
		}

		if (url === "demo") {
			this.listBook = listItem.map((i) => {
				var arrCate = [];
				// Lấy ra 10 chủ đề đầu tiên của mỗi cuốn sách
				if (i.biletcategory.length > 10) {
					arrCate = i.biletcategory.slice(0, 10);
				} else {
					arrCate = i.biletcategory;
				}
				arrCate.forEach((o: any, idx: number) => {
					var urlIm = this.imageProcessKeyword(o.id, i.code + "/image/");
					
					i.biletcategory[idx].url = urlIm;
					i.biletcategory[
						idx
					].background = window.__static + `/static/${i.code}/image/background_stretch.png`;
				});
				return {
					...i,
					biletcategory: arrCate
				};
			});
		} else {
			this.listBook = listItem.map((item) => {
				item.biletcategory.forEach((o: any, idx: number) => {
					var urlIm = this.imageProcessKeyword(o.id, item.code + "/image/");
					item.biletcategory[idx].url = urlIm;
					item.biletcategory[
						idx
					].background = window.__static + `/static/${item.code}/image/background_stretch.png`;
				});

				return {
					...item,
					biletcategory: item.biletcategory,
				};
			});
		}

		this.listBook.find((t) => {
			if (t.code == this.code) {
				this.bookCode = t;
				return this.bookCode;
			}
			return;
		});

		this.bookCode?.biletcategory.forEach((o: any, idx: number) => {
			if (url === "demo") {
				o.routerLink = ['/demo/book-detail'];
				o.queryParams = { code: this.code, id: o.id }
			} else if (url === "main") {
				o.routerLink = ['/main/book-detail'];
				o.queryParams = { code: this.code, id: o.id }
			}

		});

		this.listCategory = this.bookCode.biletcategory;
	}

	handleParams() {
		this.activatedRoute.queryParamMap.subscribe(it => {
			this.paramsObject = { ...it };
			this.code = this.paramsObject.params.code;
		});
	}

	imageProcessKeyword(filename: string, sourcefolder: string) {
		var lowerfilename = filename;
		lowerfilename = lowerfilename.toLocaleLowerCase();

		var newfilename = lowerfilename;
		if (newfilename.indexOf(" ") >= 0) {
			newfilename = newfilename.replace(/ /g, "_");
		} else if (filename.indexOf("/") >= 0) {
			newfilename = filename.replace("/", "-");
		} else if (filename.indexOf("'") >= 0) {
			newfilename = filename.replace("'", "_");
		}
		var url = window.__static + `/static/${sourcefolder}${newfilename}.png`;
		//console.log(url);
		return url;
	}
}
